import React from 'react';
import NationalyouthDay2023 from 'views/NationalyouthDay2023';

const HumanityClubPage = () => {
  return <NationalyouthDay2023 />;
};

export default HumanityClubPage;